import { useQueryClient } from '@tanstack/react-query';
import { UserKeys } from '../../../api/users-api';
import {
  isAbleToSeeUIElement,
  ToolsRoles,
} from '../../../utils/roles/client-roles';
import { Dispatch, SetStateAction } from 'react';
import SharedToolbar from '../../../shared/shared-toolbar-latest';
import SharedGridStateIconButton from '../../../shared/shared-grid-state-icon-button-latest';
import { ModuleList } from '../../../shared/analytics/module-list';
import { useNavigate } from 'react-router-dom';
import { pagesConfig } from '../../../shared/pages-config';
import CreateButton from '../../../shared/buttons/create-button';
import SharedIconButton from '../../../shared/buttons/shared-icon-button';
interface SignatureTemplatesGridToolbarProps {
  toolsRoles: string[];
  setOpenDeleteSignatureTemplate: Dispatch<SetStateAction<boolean>>;
  selectedRows: number[];
  setOpenRunAllTemplates: Dispatch<SetStateAction<boolean>>;
}

export default function SignatureTemplatesGridToolbar({
  toolsRoles,
  setOpenDeleteSignatureTemplate,
  selectedRows,
  setOpenRunAllTemplates,
}: SignatureTemplatesGridToolbarProps) {
  const queryClient = useQueryClient();
  const navigate = useNavigate();

  return (
    <SharedToolbar
      primaryButtons={
        <CreateButton
          variant="contained"
          onClick={() => {
            navigate(
              `/${pagesConfig.signatureTemplates.link}/${pagesConfig.createSignatureTemplate.link}`
            );
          }}
          disabled={
            !isAbleToSeeUIElement(toolsRoles, ToolsRoles.CreateTemplates.value)
          }
          label="Create Template"
          tooltipLabel={
            !isAbleToSeeUIElement(toolsRoles, ToolsRoles.CreateTemplates.value)
              ? `You are missing the "${ToolsRoles.CreateTemplates.name}" permission to perform this action.`
              : ''
          }
        />
      }
      secondaryButtons={
        <>
          <SharedIconButton
            variant="run"
            onClick={() => {
              setOpenRunAllTemplates(true);
            }}
            disabled={
              selectedRows.length === 0 ||
              !isAbleToSeeUIElement(
                toolsRoles || [],
                ToolsRoles.MaunalRunTemplate.value
              )
            }
            tooltipLabel={
              !isAbleToSeeUIElement(
                toolsRoles,
                ToolsRoles.MaunalRunTemplate.value
              )
                ? `You are missing the "${ToolsRoles.MaunalRunTemplate.name}" permission to perform this action.`
                : 'Run templates'
            }
          />
          <SharedIconButton
            variant="delete"
            onClick={() => {
              setOpenDeleteSignatureTemplate(true);
            }}
            disabled={
              selectedRows.length === 0 ||
              !isAbleToSeeUIElement(
                toolsRoles || [],
                ToolsRoles.DeleteTemplates.value
              )
            }
            tooltipLabel={
              !isAbleToSeeUIElement(
                toolsRoles,
                ToolsRoles.DeleteTemplates.value
              )
                ? `You are missing the "${ToolsRoles.DeleteTemplates.name}" permission to perform this action.`
                : 'Delete'
            }
          />
          <SharedIconButton
            variant="refresh"
            onClick={() => {
              queryClient.invalidateQueries({
                queryKey: [UserKeys.Signatures],
              });
              queryClient.invalidateQueries({
                queryKey: [UserKeys.SignatureRunLogs],
              });
            }}
            tooltipLabel="Refresh"
          />
          <SharedGridStateIconButton
            gridStateKey="signatureTemplatesGridStates"
            module={ModuleList.modules.automation.name}
            section={ModuleList.modules.automation.sections.signatureTemplates}
          />
        </>
      }
    />
  );
}
